import { render } from "./UserIndexList.vue?vue&type=template&id=2cb561b2&ts=true"
import script from "./UserIndexList.vue?vue&type=script&lang=ts"
export * from "./UserIndexList.vue?vue&type=script&lang=ts"

import "./UserIndexList.vue?vue&type=style&index=0&id=2cb561b2&lang=scss"

import exportComponent from "/Users/edvardaskostkevicius/WebstormProjects/rv_frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__